var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutubeSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_936_1982)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_936_1982)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_936_1982)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4202 2.74026C10.1917 2.20377 6.89666 2.20377 3.66812 2.74026C1.82186 3.12687 0.669922 4.31826 0.669922 5.87259V11.3956C0.669922 12.9736 1.82186 14.1492 3.69968 14.5516C5.3057 14.822 6.93131 14.9592 8.55992 14.9619C10.1935 14.9615 11.8243 14.8269 13.4359 14.5595C15.2664 14.2123 16.4499 12.9815 16.4499 11.4035V5.88048C16.4499 4.31037 15.2664 3.07953 13.4202 2.74026ZM11.1321 9.00492L7.18706 11.3719C7.12535 11.4095 7.05417 11.4287 6.98192 11.4272C6.91342 11.4266 6.84596 11.4104 6.78467 11.3798C6.72263 11.3422 6.67169 11.2887 6.63704 11.2249C6.60239 11.1612 6.58527 11.0894 6.58742 11.0169V6.28287C6.58801 6.213 6.60644 6.14444 6.64096 6.08368C6.67548 6.02292 6.72495 5.97199 6.78467 5.93571C6.84655 5.90256 6.91567 5.88522 6.98587 5.88522C7.05607 5.88522 7.12518 5.90256 7.18706 5.93571L11.1321 8.30271C11.1891 8.33908 11.2361 8.38922 11.2686 8.44852C11.3011 8.50782 11.3181 8.57436 11.3181 8.64198C11.3181 8.70961 11.3011 8.77615 11.2686 8.83545C11.2361 8.89475 11.1891 8.94489 11.1321 8.98125V9.00492Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_936_1982"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.78,
    height: 15.78,
    fill: "white",
    transform: "translate(0.669922 0.759766)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_936_1982"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.78,
    height: 15.78,
    fill: "white",
    transform: "translate(0.669922 0.759766)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_936_1982"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.78,
    height: 12.624,
    fill: "white",
    transform: "translate(0.669922 2.33789)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeSmall);
export default __webpack_public_path__ + "static/media/youtube-small.594e814f8715a0cb53305ae23aed8917.svg";
export { ForwardRef as ReactComponent };